module.exports = __webpack_public_path__ + "img/arrow.60360a4.svg";